import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";
import { api, errorText, scrollTo } from "@/lib/api";
import { Field, todayStr } from "@/components/site/Field";

export const GroupSignup = () => {
  const [form, setForm] = useState({ name: "", email: "", preferred_date: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/group-signups", { ...form, message: form.message || null });
      setDone(true);
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="glass rounded-[2rem] p-8 md:p-12 rise" data-testid="group-signup-success">
        <CheckCircle2 className="text-gold" size={36} strokeWidth={1.4} />
        <h3 className="font-display gold-text text-3xl mt-5">You are on the list</h3>
        <p className="mt-4 text-[#f7f1e1]/80">Thank you, beloved soul. I will reach out by email with the details of our next gathering.</p>
        <p className="mt-4 text-[#f7f1e1]/70">If your heart is moved to give, a love offering helps keep group sessions free for everyone.</p>
        <button className="btn-gold mt-8" onClick={() => scrollTo("donate")} data-testid="group-success-donate-btn">Give a Donation</button>
      </div>
    );
  }

  return (
    <div className="glass rounded-[2rem] p-8 md:p-12">
      <p className="eyebrow">Free · All are welcome</p>
      <h3 className="font-display gold-text text-3xl md:text-4xl mt-3">Join a Group Session</h3>
      <p className="mt-4 text-[#f7f1e1]/75">Heal and grow together. No payment needed.</p>
      <form onSubmit={submit} className="space-y-5 mt-8" data-testid="group-form">
        <Field label="Name"><input required className="field" placeholder="Your name" value={form.name} onChange={set("name")} data-testid="group-name-input" /></Field>
        <Field label="Email"><input required type="email" className="field" placeholder="you@email.com" value={form.email} onChange={set("email")} data-testid="group-email-input" /></Field>
        <Field label="Preferred date"><input required type="date" min={todayStr()} className="field" value={form.preferred_date} onChange={set("preferred_date")} data-testid="group-date-input" /></Field>
        <Field label="Message (optional)"><textarea rows={3} className="field" placeholder="Anything you would like me to know..." value={form.message} onChange={set("message")} data-testid="group-message-input" /></Field>
        <button type="submit" disabled={loading} className="btn-gold" data-testid="group-submit-btn">{loading ? "Sending..." : "Save My Spot"}</button>
      </form>
    </div>
  );
};
